import { createSlice } from "@reduxjs/toolkit";
import {
  getBoardDirectors,
  getExecutiveEmployees,
  getFoundingMembers,
  getGeneralAssemblyMembers,
  getOrganizationalStructure,
} from "../actions/members.actions";
import {
  BoardDirectorApi,
  ExecutiveEmployeeApi,
  FoundingMemberApi,
  GeneralAssemblyMemberApi,
  OrganizationalStructureApi,
} from "../../interfaces/Founding.members";

const initialState = {
  executiveEmployees: [] as ExecutiveEmployeeApi[],
  generalAssemblyMembers: [] as GeneralAssemblyMemberApi[],
  boardDirectors: [] as BoardDirectorApi[],
  foundingMembers: [] as FoundingMemberApi[],
  organizationalStructure: null as OrganizationalStructureApi | null,
  loading: false,
  error: null as unknown | null,
};
export const membersSlice = createSlice({
  name: "members",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExecutiveEmployees.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExecutiveEmployees.fulfilled, (state, action) => {
        state.executiveEmployees = action.payload ?? [];
        state.loading = false;
      })
      .addCase(getExecutiveEmployees.rejected, (state, action) => {
        state.executiveEmployees = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getGeneralAssemblyMembers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGeneralAssemblyMembers.fulfilled, (state, action) => {
        state.generalAssemblyMembers = action.payload ?? [];
        state.loading = false;
      })
      .addCase(getGeneralAssemblyMembers.rejected, (state, action) => {
        state.generalAssemblyMembers = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getBoardDirectors.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBoardDirectors.fulfilled, (state, action) => {
        state.boardDirectors = action.payload ?? [];
        state.loading = false;
      })
      .addCase(getBoardDirectors.rejected, (state, action) => {
        state.boardDirectors = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getFoundingMembers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFoundingMembers.fulfilled, (state, action) => {
        state.foundingMembers = action.payload ?? [];
        state.loading = false;
      })
      .addCase(getFoundingMembers.rejected, (state, action) => {
        state.foundingMembers = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOrganizationalStructure.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrganizationalStructure.fulfilled, (state, action) => {
        state.organizationalStructure = action.payload ?? null;
        state.loading = false;
      })
      .addCase(getOrganizationalStructure.rejected, (state, action) => {
        state.organizationalStructure = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default membersSlice.reducer;
